export default __webpack_public_path__ + "static/media/Integrity_Logo.fe698b81.svg";